<template>
<div class="fc-chart-wrapper" >
    <div class="visual">
        <h3 ref="h3" v-html="title"></h3>
        <div class="fact-checker-wrapper" >
            <template v-if="data.fact_check_orgs.length > 0" >
                <div 
                    v-for=" (fco) in data.fact_check_orgs "
                    :key="fco.id"
                    class="fact-checker-bar" 
                    >
                    <div class="fact-checker-icon" >
                        <img v-if="get_source_logo(fco.name)" :src="get_source_logo(fco.name)">
                        <div class="fact-checker-short-name">{{ fco.name }}</div>
                    </div>
                    <div class="fact-checker-the-bar-graph-wrapper" >
                        <div class="fact-checker-bar-graph" :style="{ width: bar_width(fco) }" >
                        </div>
                        <div v-if="!numCompareWithTop" 
                            :class="[ in_bar_graph_font_color(get_perc(fco)), in_bar_text_pos(get_perc(fco)) ]" 
                            class="in-bar-text" 
                            >{{fco.result}} of {{fco.out_of}}</div>
                    </div>
                    <div class="fact-checker-percent" >
                        <div class="fact-checker-percent-text" 
                            v-html="!numCompareWithTop ? fco.perc+'%' : fco.result" >
                        </div>
                    </div>
                </div><!-- end fact-checker-bar -->
            </template>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'fc-chart',
    props: [
        'title', 
        'data', 
        'numCompareWithTop'
    ],
    mounted: function(){
        this.$forceUpdate();
    },
    computed:{
        high_value: function(){
            var high_val = 0;

            for(var i in this.data.fact_check_orgs){
                this.data.fact_check_orgs[i].result = parseInt(this.data.fact_check_orgs[i].result);
                if(this.data.fact_check_orgs[i].result > high_val){
                    high_val = this.data.fact_check_orgs[i].result
                }
            }
      
            return high_val;        
        },

        high_value_string: function(){
            return 'repeat('+this.high_value+', 1fr)';
        },

        bar_graph_comparor:function(){
            return Math.floor((this.high_value/2));
        },

    },
    methods: {

        bar_width: function(fco) {

            if(this.numCompareWithTop) {
                return Math.round((fco.result / this.data.fact_check_orgs[0].result) * 100)+'%'
            } else {
                return this.get_perc(fco)+'%'
            }

        },

        get_source_logo: function(source){

            var logo = '';
            var folder = 'publishers/icons/';
            folder = 'https://www.realclearpolitics.com/fact_check_review/'+folder;

            switch(source){
                case 'Five Thirty Eight':
                    logo = folder + '538.png';
                break;
                case 'New York Times':
                case 'NYTimes':
                    logo = folder + 'new_york_times.png';
                break;
                case 'Huffington Post':
                    logo = folder + 'HuffPo.png';
                break;
                case 'Publisher\'s Weekly':
                    logo = folder + 'pw.png';
                break;
                case 'Politifact':
                    logo = folder + 'icon-politifact-square.png';
                break;
                case 'Washington Post':
                case 'WaPo':
                    logo = folder + 'washington_post.png';
                break;
                case 'FactCheck.org':
                case 'FactCheck':
                case 'Factcheck':
                    logo = folder + 'icon-factcheck-square.png';
                break;
                case 'Snopes':
                    logo = folder + 'icon-snopes-square.png';
                break;
                case 'Weekly Standard':
                    logo = folder + 'the-weekly-standard-logo.png';
                break;
                default:
                break;
            }

            return logo;
        },

        in_bar_graph_font_color: function(percent){
            return ( parseInt(percent) >= 62 ) ? 'in-bar-text-color-above' : 'in-bar-text-color-below';
        },

        in_bar_text_pos: function(percent){
            return ( parseInt(percent) >= 55 && parseInt(percent) <= 62 ) ? 'in-bar-text-padding-top-increase' : '';
        },

        get_perc: function(fco) {

            if(typeof fco.perc !== 'undefined') {
                return fco.perc;
            } else {
                return Math.floor((fco.result / fco.out_of) * 100);
            }
        },
        
    },
}
</script>